import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { clearAlarmOran } from '@api/alarmHistory';

import { IActiveAlarmOran } from '@interfaces/alarms/alarm';
import { IId } from '@interfaces/common/common';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes } from '@enums/common';

import { ACTIVE_ALARMS_ORAN_CLEAR } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateClearAlarmOranReturn {
	clearOranAlarm: UseMutateFunction<any, any, IId, any>;
	isLoadingClearOranAlarm: boolean;
}

export const useMutateClearAlarmOran = ({ onSuccess }: Partial<IOnSuccess>): IUseMutateClearAlarmOranReturn => {
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<{ id: string }>({
		mutationKey: [ACTIVE_ALARMS_ORAN_CLEAR],
		mutationFn: clearAlarmOran,
		onSuccess: (data: IActiveAlarmOran) => {
			if (onSuccess) onSuccess();

			dispatch(setSnackbar({
				message: responseMessages.clearAlarm(data.name),
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		clearOranAlarm: mutate,
		isLoadingClearOranAlarm: isLoading,
	};
};
